import React from 'react';

export function Label({ htmlFor, children, className = '', required = false, ...props }) {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5 ${className}`}
      {...props}
    >
      {children}
      {required && <span className="text-red-500 ml-1" aria-hidden>*</span>}
    </label>
  );
}

export default Label;
